import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';
import { BP_TABLET_MAX } from '../../../assets/styles/breakpoints';

export default styled.table`
  width: 100%;
  tbody {
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;
    tr {
      background: ${COLOR_WHITE};
      &:first-child {
        td {
          &:first-child {
            border-top-left-radius: 12px;
          }
          &:last-child {
            border-top-right-radius: 12px;
          }
        }
      }
      &:last-child {
        td {
          &:after {
            display: none;
          }
          &:first-child {
            border-bottom-left-radius: 12px;
          }
          &:last-child {
            border-bottom-right-radius: 12px;
          }
        }
      }
      td {
        padding: 18px 0px;
        text-align: center;
        position: relative;

        .top-wrap {
          padding-right: 16px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          span {
            text-align: left;
            max-width: calc(100% - 150px);
          }
        }
        .body-wrap {
          max-width: 565px;
          padding-right: 16px;
          padding-top: 8px;
          text-align: left;
        }
        .actions-wrap {
          display: flex;
          justify-content: flex-end;
          &--item {
            padding-left: 20px;
            text-align: left;
          }
          button {
            margin-left: 17px;
          }
        }

        &:after {
          content: '';
          position: absolute;
          bottom: 0px;
          height: 1px;
          width: 100%;
          background: rgba(47, 46, 65, 0.1);
          left: 0;
        }
        &:first-child {
          border-right: 1px solid rgba(47, 46, 65, 0.1);
          text-align: left;
          padding-left: 32px;
          &:after {
            width: calc(100% - 32px);
            right: 0px;
            left: auto;
          }
        }
        &:last-child {
          padding-right: 32px;
          text-align: right;
          width: 393px;
          &:after {
            width: calc(100% - 32px);
            right: auto;
            left: 0px;
          }
        }
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    tbody {
      tr {
        td {
          .top-wrap {
            padding-right: 0px;
            flex-wrap: wrap;
            span {
              max-width: 100%;
              width: 100%;
            }
          }
          .body-wrap {
            padding-right: 0px;
          }
          .actions-wrap {
            justify-content: space-between;
            padding: 20px 0px;
            &--item {
              padding-left: 0px;
            }
          }
          &:first-child {
            border-right: none;
          }
          &:last-child {
            padding-right: 32px;
            text-align: right;
            width: 100%;
            &:after {
              width: calc(100%);
              right: auto;
              left: 0px;
            }
          }
        }
      }
    }
  }
`;
